import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {mintNewProject} from "nft/mint.js";
import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js";
import { Button } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import '../../Mint.scss';

const MintModal = ({sequencerEngine, onClickCancel}) => { 
    let [title, setTitle] = useState("");
    let [editions, setEditions] = useState(8);
    let [price, setPrice] = useState(0.1);
    let [minting, setMinting] = useState(false);
    let [minted, setMinted] = useState(false);

    const onClickMint = useCallback(async () => {
        setMinting(true);
        await mintNewProject(sequencerEngine, title, editions, price*Math.pow(10,18));
        setMinted(true);
        setMinting(false);
    }, [price, title, editions, setMinting, setMinted]);

    return (
        <Modal dialogClassName="mint-modal preset-modal render-modal" show={true} onHide={onClickCancel}>
          <Modal.Header closeButton>
            <Modal.Title>Mint NFT</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {minting ?
             <UnknownProgressBar text="Minting your nft"/> :
             <div>
               <input placeholder="Title your work" value={title} type="text" onChange={e => setTitle(e.target.value)}/>
               <div className="editions">
                 <div className="value">
                   Editions: {editions}
                 </div>
               <ReactBootstrapSlider
                 value={editions}
                 change={(e) => setEditions(e.target.value)}
                 step={1}
                 max={1000}
                  min={1}
                  orientation="horizontal"
                  reversed={false}
                  />
               </div>
               <div className="price">
                 <div className="value">
                   Price: {price} eth
                 </div>
                <ReactBootstrapSlider
                  value={price}
                  change={(e) => setPrice(e.target.value)}
                  step={0.001}
                  max={1}
                  min={0.001}
                  orientation="horizontal"
                  reversed={false}
                  />
               </div>
                
             </div>
        }
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClickMint}>
              Mint!
            </Button>
            <Button variant="primary" onClick={onClickCancel}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MintModal);
